<!--
/*
Important
This file is used only for the vue3 application.
Changes made here will not be reflected in the Vue2 application.
You need to make changes in the vue3 file also
Vue2 file: Velocity.PrimaryOffersites.Web\wwwroot\js\components\Rotationalbanners.vue
Any clarifications contact Leela Directly
*/

-->
<template>
  <div>
    <component
      :is="componentName"
      v-if="componentName"
      :banners="bannersData"
      :sectionid="sectionid"
      :hidearrows="hidearrows"
      :hidecontrols="hidecontrols"
      :render="render"
      :controlscolor="controlscolor"
      :next-arrow-icon="nextArrowIcon"
      :previous-arrow-icon="previousArrowIcon"
      :banner-options="bannerOptions"
      :automated-banner-options="automatedBannerOptions"
      :apply-speed-values="applySpeedValues"
    >
    </component>
  </div>
</template>

<script>
import PrimaryRotationalbanners from "./PrimaryRotationalBanners/PrimaryRotationalBanners.vue";
import BmwRotationalbanners from "./BmwRotationalbanners/BmwRotationalBanners.vue";
import ToyotaRotationalbanners from "./ToyotaRotationalbanners/ToyotaRotationalbanners.vue";

import { LayoutConstants } from "@/js/constants/LayoutConstants";
import { isToyotaTheme } from "@/js/constants/ThemeConstants";

export default {
  components: {
    PrimaryRotationalbanners,
    BmwRotationalbanners,
    ToyotaRotationalbanners,
  },
  props: {
    sectionid: {
      required: true,
    },
    bannersData: {
      required: false,
    },
    hidearrows: {
      required: false,
      default: false,
    },
    hidecontrols: {
      required: false,
      default: false,
    },
    render: {
      required: false,
      default: "",
      type: String,
    },
    controlscolor: {
      type: String,
      default: "",
    },
    bannerType: {
      required: false,
      default: "",
      type: String,
    },
    nextArrowIcon: {
      required: false,
      default: "",
      type: String,
    },
    previousArrowIcon: {
      required: false,
      default: "",
      type: String,
    },
    bannerOptions: {
      required: false,
      default() {
        return {};
      },
      type: Object,
    },
    automatedBannerOptions: {
      required: false,
      default() {
        return {};
      },
      type: Object,
    },
    applySpeedValues: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      componentName: "",
    };
  },
  mounted() {
    this.stickyRotationalBanner();
  },
  created() {
    if (isToyotaTheme()) {
      this.componentName = "ToyotaRotationalbanners";
      return;
    }
    if (this.bannerType === "primary") {
      this.componentName = "PrimaryRotationalbanners";
      return;
    }

    switch (window.masterLayoutName.toLowerCase()) {
      case LayoutConstants.WEBSITE_BMW:
        this.componentName = "BmwRotationalbanners";
        break;
      case LayoutConstants.WEBSITE_FRAME:
        this.componentName = "BmwRotationalbanners";
        break;
      default:
        this.componentName = "PrimaryRotationalbanners";
        break;
    }
  },
  methods: {
    stickyRotationalBanner() {
      if (document.querySelector(".is_Sticky_Banner")) {
        let inventoryTopOffset = document.querySelector("#disasterBanner").offsetTop;
        if (inventoryTopOffset) {
          if (document.querySelector(".inventorynew-iframe")) {
            document
              .querySelector(".inventorynew-iframe")
              .classList.add("rotational_banner_sticky");
            if (document.querySelector(".sticky-top-filters")) {
              document.querySelector(".vdp-top-filters").classList.remove("sticky-top-filters");
            }
          }
          document.querySelector(".rotational_banner_sticky").style.top = `${inventoryTopOffset}px`;
          if (document.querySelector(".h-100.overflowy-hidden")) {
            document.querySelector(".h-100.overflowy-hidden").style.overflow = "initial";
          }
          if (document.querySelector("#_website_primary")) {
            document.querySelector("#_website_primary").style.overflow = "initial";
          }
          document.querySelector("body").style.overflowX = "initial";
        }
      }
    },
  },
};
</script>
